module.exports = __webpack_public_path__ + "static/img/book_02.ab76d3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/events/book_02.png
// module id = L2KI
// module chunks = 0